<template>
  <div class="upload-pannel">
    <form class="form-horizontal">
      <div class="form-group" style='align:left'>
          <label class="control-label col-sm-3">设备所属小区</label>
          <div class="col-sm-7" id='app_name'>
              <select class="form-control" v-model="communityId">
                <option v-for="item in items" :value="item.id">{{item.description}}</option>
              </select>
          </div>
      </div>

      <div class="form-group" style='align:left'>
          <label class="control-label col-sm-3">选中文件</label>
          <div class="col-sm-7">
              <div class="fileinput fileinput-new" data-provides="fileinput">
              <span class="btn green btn-file">
                <span class="fileinput-new">{{fileName}}</span>
                <i class="fa fa-upload"></i>
                <input
                  type="file"
                  ref="myFiles"
                  id="fileupload"
                  @change="selectDone"
                  accept="text/plain"
                />
              </span>
            </div>
          </div>
      </div>
      <div style="text-align:center">
        <button type='button' class="btn blue" aria-hidden="true" @click="upload">确定</button>
        <button type='button' class="btn" aria-hidden="true" @click="cancel">关闭</button>
      </div>
    </form>
  </div>
</template>

<script>
// import http from '../lib/utils/request.js'
import {MSG_ID, K_LOGINED_USER} from '../lib/constant.js'
import mixins from '../mixins/index'
import db from '../store/local'
import fileutil from '../lib/utils/fileutil.js'
import commonMethods from '../lib/methods/common.js'

export default {
  name: 'upload-pannel',
  mixins: mixins,
  data () {
    return {
      url: '',
      items: [],
      communityId: '',
      fileName: '选择...'
    }
  },
  mounted () {
    this.items = db.get(K_LOGINED_USER).account.items
  },
  methods: {
    cancel () {
      window.emitter.emit(MSG_ID.MSG_UI_HIDE_MODAL)
    },
    upload () {
      if (!this.communityId) {
        window.emitter.emit(MSG_ID.MSG_UI_TIP_WARN, '设备所属小区必选')
        return
      }
      let file = this.$refs.myFiles.files[0]
      let size = file.size
      size = size / (1024 * 1024)
      if (size < 10 && /\/(?:plain)/i.test(file.type)) {
        window.emitter.emit(MSG_ID.MSG_UI_CONFIRM, `你确定要导入该文件？: ${file.name}`, () => {
          this.doUpload(file)
        })
      } else {
        window.emitter.emit(MSG_ID.MSG_UI_TIP_WARN, '请选择小于10MB的文件，文件类型必须为纯文本(.txt)')
        return false
      }
    },
    doUpload (file) {
      // 发起一个请求
      fileutil.upload(this.url, file, (data) => {
        console.log('ok')
        this.hideLopeLoading()
        window.emitter.emit(MSG_ID.MSG_UI_TIP_SUCC, '上传成功')
        window.emitter.emit(MSG_ID.MSG_UI_HIDE_MODAL)
        window.emitter.emit(MSG_ID.MSG_LOCK_REFRESH)
      }, (res) => {
        let msg = JSON.stringify(res)
        window.alert('error! \n' + msg)
      }, [{ key: 'community_id', val: this.communityId }])
    },
    selectDone () {
      console.log('选中文件啦')
      let file = this.$refs.myFiles.files[0]
      let size = file.size
      console.log(size)
      size = size / (1024 * 1024)
      console.log(size)
      console.log(file.name)
      if (size < 10 && /\/(?:plain)/i.test(file.type)) {
        this.fileName = file.name
      } else {
        window.emitter.emit(MSG_ID.MSG_UI_TIP_WARN, '请选择小于10MB的文件，文件类型必须为纯文本(.txt)')
        return false
      }
    },
    onShowInModal (options) {
      if (options.url) {
        this.url = options.url
      }
      this.items = db.get(K_LOGINED_USER).account.communities
    },
    onHideInModal (options) {
      this.url = ''
      this.items = []
      this.communityId = ''
    },
    ...commonMethods
  }
}
</script>
<style scoped>
.your-selector {
  display: inline;
  max-width: 120px;
}
</style>



// WEBPACK FOOTER //
// UploadPannel.vue?9e0166d8